import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteExecutionImage } from '@/lib/api/generated/api';

import { toExecutionImageError } from '../errors';
import { executionImageKeys } from '../queryKeys';

/**
 * Remove a catalog entry. The backend rejects deleting the current default
 * (`EXECUTION_IMAGE_CANNOT_DELETE_DEFAULT`, mapped via `errors.ts`) as a
 * second line of defense — the delete control is already disabled/blocked
 * client-side first (FR-011, SC-004).
 */
export function useDeleteExecutionImage(workspaceId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (imageId: string): Promise<void> => {
      const response = await deleteExecutionImage(workspaceId, imageId);
      if (response.status === 204) return;
      throw toExecutionImageError(response.status, response.data);
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: executionImageKeys.all(workspaceId),
      });
    },
  });
}
